import { render, staticRenderFns } from "./ModalIdle.vue?vue&type=template&id=9cd9aa56&scoped=true&"
var script = {}
import style0 from "./ModalIdle.vue?vue&type=style&index=0&id=9cd9aa56&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd9aa56",
  null
  
)

export default component.exports